/** Rubrique Établissement : identité, adresse, TVA, saison, langue par défaut. */
import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { metaApi, parametresApi } from '../../../services/api';
import { Button, Spinner, Card } from '../../../components/ui/kit';
import { useAuth } from '../../../context/AuthContext';

const MONTHS = ['—', 'Janv', 'Févr', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'];

export default function Etablissement() {
  const { tenant, refreshUser } = useAuth();
  const [est, setEst] = useState(null);
  const [inst, setInst] = useState(null);
  useEffect(() => { metaApi.settings().then(setEst); parametresApi.appInstance().then(setInst).catch(() => {}); }, []);
  useEffect(() => {
    if (!tenant) return;
    setEst((e) => (e ? { ...e, type: e.type ?? tenant.type, slug: e.slug ?? tenant.slug } : e));
  }, [tenant]);
  if (!est) return <Spinner />;

  const set = (k, v) => setEst({ ...est, [k]: v });
  const save = async () => { await parametresApi.updateEstablishment(est); await refreshUser(); toast.success('Établissement enregistré'); };

  return (
    <div className="max-w-[640px]">
      <h2 className="font-title text-3xl mb-5">Établissement</h2>
      <Card className="p-5 space-y-4">
        <Field label="Nom"><input className="vd-input h-9 w-full" value={est.name || ''} onChange={(e) => set('name', e.target.value)} data-testid="est-name" /></Field>
        <Field label="Lien public (slug)">
          <input className="vd-input h-9 w-full" value={est.slug ?? ''} onChange={(e) => set('slug', e.target.value)} data-testid="est-slug" placeholder="maison-des-monts-bleus" />
          <p className="text-[11px] text-n500 mt-1">Adresse de la carte publique : <span className="nums">/c/{est.slug ?? ''}</span> — attention : la changer invalide les QR codes déjà imprimés.</p>
        </Field>
        <Field label="Type d'établissement">
          <select className="vd-input h-9 w-full" value={est.type || 'pro'} onChange={(e) => set('type', e.target.value)} data-testid="est-type">
            <option value="pro">Professionnel (restaurant, caviste…)</option>
            <option value="particulier">Particulier</option>
          </select>
        </Field>
        <Field label="Adresse (sert au calcul des distances)"><input className="vd-input h-9 w-full" value={est.address || ''} onChange={(e) => set('address', e.target.value)} data-testid="est-address" /></Field>
        <div className="grid grid-cols-2 gap-4">
          <Field label="Site web"><input className="vd-input h-9 w-full" value={est.website || ''} onChange={(e) => set('website', e.target.value)} placeholder="https://…" data-testid="est-website" /></Field>
          <Field label="Téléphone"><input className="vd-input h-9 w-full" value={est.phone || ''} onChange={(e) => set('phone', e.target.value)} placeholder="+33…" data-testid="est-phone" /></Field>
        </div>
        <Field label="Email"><input className="vd-input h-9 w-full" value={est.email || ''} onChange={(e) => set('email', e.target.value)} placeholder="contact@…" data-testid="est-email" /></Field>
        <div className="grid grid-cols-2 gap-4">
          <Field label="TVA (%)"><input type="number" className="vd-input h-9 w-full" value={est.tva ?? ''} onChange={(e) => set('tva', Number(e.target.value))} /></Field>
          <Field label="Langue par défaut">
            <select className="vd-input h-9 w-full" value={est.default_language || 'fr'} onChange={(e) => set('default_language', e.target.value)}>
              {['fr', 'en', 'nl', 'de', 'es'].map((l) => <option key={l} value={l}>{l.toUpperCase()}</option>)}
            </select>
          </Field>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <Field label="Saison — début">
            <select className="vd-input h-9 w-full" value={est.season_start_month || 5} onChange={(e) => set('season_start_month', Number(e.target.value))}>
              {MONTHS.slice(1).map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
            </select>
          </Field>
          <Field label="Saison — fin">
            <select className="vd-input h-9 w-full" value={est.season_end_month || 9} onChange={(e) => set('season_end_month', Number(e.target.value))}>
              {MONTHS.slice(1).map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
            </select>
          </Field>
        </div>
        <Button variant="primary" onClick={save} data-testid="est-save">Enregistrer</Button>
      </Card>
      {inst && (
        <Card className="p-5 mt-5" data-testid="instance-card">
          <p className="font-title text-lg mb-3">Instance d'application</p>
          <p className="text-sm text-n700 mb-1">URL d'accès : <span className="nums">{inst.app_url || window.location.origin}</span></p>
          <p className="text-sm text-n700">ID d'instance : <span className="nums">{inst.instance_id}</span></p>
        </Card>
      )}
    </div>
  );
}

function Field({ label, children }) {
  return <label className="block"><span className="kicker block mb-1">{label}</span>{children}</label>;
}
